import NextLink from 'next/link';

import { Modal } from '@frontendmentorio/design-system-v2';

export default function CSSModal({ modal }) {
  return (
    <Modal modal={modal}>
      <Modal.Heading>How does the CSS report work?</Modal.Heading>

      <p>
        When a solution is submitted, we use{' '}
        <NextLink
          className="underline hover:no-underline"
          href="https://stylelint.io/"
        >
          stylelint
        </NextLink>{' '}
        to run an automated check on the CSS code.
      </p>

      <p>
        We've added some of our own linting rules based on recommended best
        practices. These rules are prefixed with{' '}
        <code className="bg-neutral-200 font-mono rounded-sm">
          frontend-mentor/
        </code>{' '}
        which you'll see at the top of each issue in the report.
      </p>

      <p>
        The report will audit all CSS, SCSS and Less files in your repository.
      </p>
    </Modal>
  );
}
